import { createSlice } from '@reduxjs/toolkit'

const endpoints = createSlice({
    name: 'endpoints',
    initialState: {
        dialogVisible: false,
        openEndpoints: [],
        currentEndpointId: null
    },
    reducers: {
        setDialogVisibility: (state, action ) => {
            state.dialogVisible = action.payload
        },
        openEndpoint: ( state, action ) => {

            const opened = state.openEndpoints.filter( endpoint => endpoint.id === action.payload.id )

            if (!opened.length) {
                state.openEndpoints.push(action.payload)
                state.currentEndpointId = action.payload.id
            } else {
                state.currentEndpointId = action.payload.id
            }

        },
        closeEndpoint: (state, action) => {
            state.openEndpoints = state.openEndpoints.filter( endpoint => endpoint.id !== action.payload.id)
            const last = state.openEndpoints.slice(-1).pop()
            state.currentEndpointId = last ? last.id : null
        },
        setCurrentEndpoint: (state, action ) => {
            state.currentEndpointId = action.payload
        }
    }
})

export default endpoints

